module.exports = __webpack_public_path__ + "static/media/s18.aa6c77b8.png";